import { useContext, useRef, useState } from "react";

import { useIntl } from "react-intl";

import { IconButton } from "@atlaskit/button-next/new";
import { FormFields } from "@atlaskit/feedback-collector";
import MegaphoneIcon from "@atlaskit/icon/core/megaphone";
import { Box } from "@atlaskit/primitives-next";

import Flag from "../../../contexts/FlagProvider";
import { messages } from "../messages";

import { FeedbackCollectorModal } from "./feedback-collector-modal";
import { useFeedbackCollectorAnalytics } from "./hooks";

export const FeedbackCollector = () => {
    const ref = useRef<HTMLButtonElement | null>(null);
    const [isOpen, setIsOpen] = useState(false);
    const { formatMessage } = useIntl();

    const { showFlag } = useContext(Flag.Context);
    const handleClose = () => setIsOpen(false);

    const {
        sendFeedbackCollectorOpenButtonClickUIEvent,
        sendFeedbackCollectorSubmitButtonClickUIEvent
    } = useFeedbackCollectorAnalytics();

    const handleOpen = () => {
        setIsOpen(true);
        sendFeedbackCollectorOpenButtonClickUIEvent();
    };

    const handleSubmit = (formFields: FormFields) => {
        setIsOpen(false);
        showFlag({
            autoDismiss: true,
            iconType: "success",
            title: formatMessage(messages.feedbackSubmittedTitle),
            description: formatMessage(messages.feedbackSubmittedDescription),
            id: "feedback-submitted-flag"
        });
        sendFeedbackCollectorSubmitButtonClickUIEvent(formFields.type);
    };

    return (
        <Box
            id="fastshift-feedback-collector"
            testId="fastshift-feedback-collector"
        >
            <IconButton
                appearance="subtle"
                label={formatMessage(messages.iconButtonLabel)}
                onClick={handleOpen}
                icon={MegaphoneIcon}
                ref={ref}
            />

            {isOpen && (
                <FeedbackCollectorModal
                    onClose={handleClose}
                    onSubmit={handleSubmit}
                    shouldReturnFocusRef={ref}
                />
            )}
        </Box>
    );
};
